<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      section.page-top-image
        .image
          img(src="../assets/concept_image_01.jpg")
        .text
          h1.title Reserve
            span.title-caption 予約

  parallax-inview
    animation-fade-in-up
      section.page-description
        p LINEから簡単に予約することができます。<br>以下の手順を参考にお気軽にご登録ください。
        //- p.brfore-settlement ※事前決済サービスを導入しております。<br><a href="https://reserva.be/shampooselection/course/list" target="_blenk">こちら</a>よりご登録ください。

  //- parallax-inview
  //-   animation-fade-in-up
  //-     section.counseling
  //-       p Lineにて事前のオンラインカウンセリングを承っております。<br>お気軽にLineにてお問い合わせください。

  parallax-inview(v-if="$mq === 'pc'")
    animation-fade-in-up
      section.section
        h2.title.reserve-title 1. QRコードでLINEの友達に追加
        p.text LINEアプリの友だちタブを開き、画面右上にある友だち追加ボタンに[QRコード]をタップし、コードリーダーでQRコードでスキャンしてください。<br>コードをスキャンすると、『予約shampoo selection』というアカウントがでてくるので[追加]ボタンを押し友達に追加してください。
        img.section-image(src="../assets/line_qrcode.png")

  parallax-inview(v-if="$mq === 'sp'")
    animation-fade-in-up
      section.section
        h2.title.reserve-title 1. LINEの友達に追加
        p.text 「Lineで予約」ボタンを押すとラインアプリが起動しします。『予約shampoo selection』というアカウントがでてくるので[追加]ボタンを押し友達に追加してください。
        a.line-link(href="https://line.me/R/ti/p/%40659poqxm" target="_blank")
          img.line-image(src="../assets/line_reserve.png")

  parallax-inview
    animation-fade-in-up
      section.section
        h2.title.reserve-title 2. トークルームでお店の予約
        p.text 追加したアカウントのトークルームに入り、トークに従ってお客様情報をご登録ください。登録が完了すると、ご予約が行えますので登録後予約ボタンを押しアカウントに従ってご予約ください。
        img.section-image(src="../assets/reserve_image_02.png")

</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Reserve',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  margin: 0 25px 80px;

  .text {
    text-align: left;
    margin-bottom: 20px;
  }
}

.section-image {
  padding: 20px 40px;
  box-sizing: border-box;
}

.line-link {
  display: block;
  padding: 20px 40px 20px;
  box-sizing: border-box;
}

.line-image {
  width: 100%;
}

.reserve-title {
  text-align: left;
}

.counseling {
  background: #fff;
  color: #000;
  padding: 20px;
  margin-bottom: 40px;
}

.brfore-settlement {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Reserve.vue